import React from 'react';
import cn from 'classnames/bind';
import { ButtonType } from '../../../../../../components/common/button';
import { Visibility } from '../../../../../../types/common-types';
import Item from '../items/interface';
import { toUpperLatter } from '../../../../../../utils/utils';
import './style.scss';

interface RowProps {
  items: Item[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elm: Record<string, React.FC<any>>;
  onChange: () => void;
  onSubmit: () => void;
  getErrorMsg: () => void;
}

const getSumWidth = (items: Item[]) => {
  return items.reduce((acc, i) => {
    const w = i.w ? +i.w : 1;
    return acc + w;
  }, 0);
};

const Row: React.FC<RowProps> = ({
  items,
  elm,
  onChange,
  onSubmit,
  getErrorMsg,
}) => {
  const renderItems = () => {
    const sumWidth = getSumWidth(items);
    const rItems: React.ReactNodeArray = [];
    let index = 0;
    const COUNTRY_CODE = process.env.COUNTRY_CODE || '';
    items.forEach((item: Item) => {
      if (!item.class) return;
      const itemName = toUpperLatter(item.class);
      const ItemComp = elm[itemName];
      if (!ItemComp) return;
      const w = item.w ? +item.w : 1;
      const relW = (w / sumWidth) * 100;
      const style = {
        width: `${relW}%`,
      };
      rItems.push(
        <div
          key={`row_${item.id}_${index}`}
          styleName="row__item"
          style={style}
        >
          <ItemComp
            onChange={onChange}
            onSubmit={onSubmit}
            getErrorMsg={getErrorMsg}
            countryCode={COUNTRY_CODE}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...item}
          />
        </div>
      );
      index += 1;
    });
    return rItems;
  };

  const hidden =
    items.every(i => i.visibility === Visibility.Hidden) || items.length === 0;
  const iconButtonsOnly =
    items.every(i => i.class === 'button' && i.type === ButtonType.Icon) ||
    items.length === 0;
  return (
    <div styleName={cn('row', { hidden, center: iconButtonsOnly })}>
      {renderItems()}
    </div>
  );
};
export default Row;
